import classesCss from './AboutPrograms.module.css';
import AboutProgram from "../../Components/AboutProgram/AboutProgram";
import IconButton from '@mui/material/IconButton';
import MultiCarousel from 'react-multi-carousel';

const AboutPrograms = ({programs, length}) => {
    const responsive = {
      large: {
        breakpoint: {max: 2000, min: 1500},
        items: 4,
      },
      desktop: {
        breakpoint: {max: 1500, min: 800},
        items: 3
      },
      tablet: {
        breakpoint: {max: 800, min: 500},
        items: 2
      },
      mobile: {
        breakpoint: {max: 500, min:0},
        items: 1
      }
    };
    return (
        <MultiCarousel responsive={responsive}
          arrows={false}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={4000}
          showDots={true}>
          {
              programs.map(({image, link, title, description}, index) => {
                return (
                    <div className={"flex justify-center items-center w-70"}>
                      <AboutProgram image={image} link={{
                          text: link.text,
                          href: link.href,
                      }} title={title} description={description}
                      classes={"w-40"}/>
                    </div>
                )
              })
          }
        </MultiCarousel>
    );
};

export default AboutPrograms;
